import { Icon } from '@cbhq/cds-web/icons';
import { Spinner } from '@cbhq/cds-web/loaders';

type StatusIconProps = {
  status: 'COMPLETE' | 'PENDING' | 'FAILED';
};

export function StatusIcon({ status }: StatusIconProps) {
  switch (status) {
    case 'COMPLETE':
      return <Icon name="circleCheckmark" size="m" color="positive" />;
    case 'FAILED':
      return <Icon name="circleCross" size="m" color="negative" />;
    default:
      return <Spinner size={2} color="primary" />;
  }
}
